import React from 'react'
import TerminalContractsDraftLayout from '../features/TerminalContracts/TerminalContractsDraftLayout'

import Index from '../views/dashboard/index'
import Settings from '../views/dashboard/menu/settings'

import { Routes, Route } from 'react-router-dom'

//TransitionGroup
import {TransitionGroup,CSSTransition} from "react-transition-group";

//Lists
import Transactions from '../views/dashboard/lists/transactions';
import Terminals from '../views/dashboard/lists/terminals';
import TerminalContracts from '../views/dashboard/details/terminal/terminalContracts';
import Vmcs from '../views/dashboard/lists/vmcs';
import Locations from '../views/dashboard/lists/locations';
import Products from '../views/dashboard/lists/products';
import Alerts from '../views/dashboard/lists/alerts';
import AlertDefinitions from '../views/dashboard/lists/alertDefinitions';
import Sites from '../views/dashboard/lists/sites';
import Profit from '../views/dashboard/lists/profit';
import ProductSales from '../views/dashboard/lists/productSales';
import Transaction from '../views/dashboard/details/transaction/transaction';
import Terminal from '../views/dashboard/details/terminal/terminal'
import Product from '../views/dashboard/details/product/product'
import Alert from '../views/dashboard/details/alert/alert'
import AlertDefinition from '../views/dashboard/details/alertDefinition/alertDefinition'
import Site from '../views/dashboard/details/site/site'
import Location from '../views/dashboard/details/location/location'
import TerminalMdbSetting from '../views/dashboard/details/terminal/terminalMdbSetting'
import TerminalContract from '../views/dashboard/details/terminal/terminalContract'
import Vmc from '../views/dashboard/details/vmc/vmc'
import VmcLinkedProducts from '../views/dashboard/details/vmc/vmc-linked-products'
import ProductVmcLink from '../views/dashboard/details/vmc/product-vmc-link'
import LinkLocationToTerminal from '../views/dashboard/items-linkers/location-to-terminal'
import LinkLocationToVmc from '../views/dashboard/items-linkers/location-to-vmc'
import LinkVmcToTerminal from '../views/dashboard/items-linkers/vmc-to-terminal'
import LinkProductToVmc from '../views/dashboard/items-linkers/product-to-vmc'
import LinkVmcTypeToVmc from '../views/dashboard/items-linkers/vmcType-to-vmc'


const DefaultRouter = () => {
    return (
        <TransitionGroup>
            <CSSTransition classNames="fadein" timeout={300}>
                <Routes>
                    <Route path="/" element={<Index />}  />

                    <Route path="/menu/settings" element={<Settings /> } />

                    {/*lists */}
                    <Route path="/lists/transactions" element={<Transactions />} />
                    <Route path="/lists/terminals" element={<Terminals />} />                    
                    <Route path="/lists/vmcs" element={<Vmcs />}  />
                    <Route path="/lists/locations" element={<Locations />}  />
                    <Route path="/lists/products" element={<Products />}  />
                    <Route path="/lists/alerts" element={<Alerts />}  />
                    <Route path="/lists/alertDefinitions" element={<AlertDefinitions />}  />
                    <Route path="/lists/sites" element={<Sites />}  />
                    <Route path="/lists/profit" element={<Profit />}  />
                    <Route path="/lists/productSales" element={<ProductSales />}  />


                    {/*Detail pages*/}
                    <Route path="/details/transaction" element={<Transaction />}  />
                    <Route path="/details/terminal" element={<Terminal />}  />
                    <Route path="/details/terminal-mdb-settings" element={<TerminalMdbSetting />}  />             
                    <Route path="/details/vmc" element={<Vmc />}  />
                    <Route path="/details/vmc/vmc-linked-products" element={<VmcLinkedProducts />}  />
                    <Route path="/details/vmc/product-vmc-link" element={<ProductVmcLink />}  />
                    <Route path="/details/product" element={<Product />}  />
                    <Route path="/details/alert" element={<Alert />}  />
                    <Route path="/details/alertDefinition" element={<AlertDefinition />}  />
                    <Route path="/details/site" element={<Site />}  />
                    <Route path="/details/location" element={<Location />}  />

                    {/*Link pages*/}
                    <Route path="/items-linkers/location-to-terminal" element={<LinkLocationToTerminal />}  />
                    <Route path="/items-linkers/location-to-vmc" element={<LinkLocationToVmc />}  />
                    <Route path="/items-linkers/vmc-to-terminal" element={<LinkVmcToTerminal />}  />
                    <Route path="/items-linkers/product-to-vmc" element={<LinkProductToVmc />}  />
                    <Route path="/items-linkers/vmcType-to-vmc" element={<LinkVmcTypeToVmc />}  />

                    <Route element={<TerminalContractsDraftLayout />}>
                        <Route path="/lists/terminal-contracts" element={<TerminalContracts />} />
                        <Route path="/details/terminal-contract" element={<TerminalContract />} />
                    </Route>
                </Routes>
            </CSSTransition>
        </TransitionGroup>
    )
}

export default DefaultRouter
